import { appVersion } from '../components/Settings';
import { getPlatform, isNative, getBrowserDeviceType } from '../utils/platformUtils';

export const SUPPORT_EMAIL = 'support@upscale.li';

const BUG_SUBJECT = 'upScale bug report';

const field = (value) => {
  const clean = (value || '').toString().trim();
  return clean || 'unknown';
};

export function buildBugReportText({ version, platform, device, userId, screen } = {}) {
  const user = (userId || '').toString().trim() || 'guest';
  return [
    'What happened:',
    '',
    '',
    '',
    '---',
    `upScale ${field(version)}`,
    `Platform: ${field(platform)}`,
    `Device: ${field(device)}`,
    `User: ${user}`,
    `Screen: ${field(screen)}`,
  ].join('\n');
}

export function buildBugReportMailto(meta = {}) {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(BUG_SUBJECT)}&body=${encodeURIComponent(
    buildBugReportText(meta)
  )}`;
}

export function buildSupportMailto() {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('upScale')}`;
}

export function collectBugReportMeta({ userId, screen } = {}) {
  const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  const device = isNative() ? ua : `${getBrowserDeviceType()} · ${ua}`;
  return {
    version: appVersion,
    platform: getPlatform(),
    device,
    userId: userId || '',
    screen: screen || '',
  };
}
